import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'

import { useFormatNumber } from '@hooks/useFormatNumber'

interface PriceRangeProps {
  minAmount?: number
  maxAmount?: number
}

export const PriceRange: React.FC<PriceRangeProps> = ({ minAmount = 0, maxAmount = 0 }) => {
  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()

  if (minAmount >= 0 && minAmount !== maxAmount) {
    return (
      <Body2>
        {formatMoney(minAmount)}- {formatMoney(maxAmount)}
        {'/'}
        {t('Subscriptions.mth')}
      </Body2>
    )
  } else {
    return (
      <Body2>
        {formatMoney(maxAmount)}
        {'/'}
        {t('Subscriptions.mth')}
      </Body2>
    )
  }
}
